import CustomerNotification, {
  CustomerNotificationTypes,
} from '@/models/customer-notification'
import ProcessedCustomerNotification from '@/models/processed-customer-notification'

import BaseNotification from './BaseNotification'
import BookingCancelled from './helperServices/BookingCancelled'
import BookingExpired from './helperServices/BookingExpired'
import BookingExpiresTomorrow from './helperServices/BookingExpiresTomorrow'
import DepositRequiredToSecureBooking from './helperServices/DepositRequiredToSecureBooking'
import FullPaymentRequired from './helperServices/FullPaymentRequired'
import FullPaymentRequiredToSecureBooking from './helperServices/FullPaymentRequiredToSecureBooking'
import NewMessage from './helperServices/NewMessage'
import PassengerAwaitingConfirmation from './helperServices/PassengerAwaitingConfirmation'
import PassengerCancelled from './helperServices/PassengerCancelled'
import PassengerConfirmed from './helperServices/PassengerConfirmed'
import PaymentIsOverdue from './helperServices/PaymentIsOverdue'

export default class CustomerNotificationService {
  notification: CustomerNotification

  constructor(notification: CustomerNotification) {
    this.notification = notification
  }

  call(): ProcessedCustomerNotification {
    switch (this.notification.type) {
      case CustomerNotificationTypes.BookingCancelled:
        return new BookingCancelled(this.notification).call()
      case CustomerNotificationTypes.PassengerCancelled:
        return new PassengerCancelled(this.notification).call()
      case CustomerNotificationTypes.FullPaymentRequired:
        return new FullPaymentRequired(this.notification).call()
      case CustomerNotificationTypes.PaymentIsOverdue:
        return new PaymentIsOverdue(this.notification).call()
      case CustomerNotificationTypes.FullPaymentRequiredToSecureBooking:
        return new FullPaymentRequiredToSecureBooking(this.notification).call()
      case CustomerNotificationTypes.DepositRequiredToSecureBooking:
        return new DepositRequiredToSecureBooking(this.notification).call()
      case CustomerNotificationTypes.BookingExpiresTomorrow:
        return new BookingExpiresTomorrow(this.notification).call()
      case CustomerNotificationTypes.BookingExpired:
        return new BookingExpired(this.notification).call()
      case CustomerNotificationTypes.NewMessage:
        return new NewMessage(this.notification).call()
      case CustomerNotificationTypes.PassengerAwaitingConfirmation:
        return new PassengerAwaitingConfirmation(this.notification).call()
      case CustomerNotificationTypes.PassengerConfirmed:
        return new PassengerConfirmed(this.notification).call()
      default:
        return new BaseNotification(this.notification).call()
    }
  }
}
